
/*****FEMALE***********************************************/
/*notes 2023 :added: style_short_buzz_cut (done), style_short_spiky (done)
shape becomes short (done)

-
 */
export const FEMALE_SHAPE = {
  style_long:'style_long',
  style_long_wide:'style_long_wide',
  style_medium:'style_medium',
  style_medium_wide:'style_medium_wide',
  style_ponytail:'style_ponytail',
  style_short: 'style_short',
  style_short_buzz_cut:'style_short_buzz_cut',
  style_short_spiky:'style_short_spiky',
  style_tied_up:'style_tied_up',
  style_very_short:'style_very_short',

  // shape_long:'shape_long',
  // shape_long_wide:'shape_long_wide',
  // shape_medium:'shape_medium',
  // shape_medium_wide:'shape_medium_wide',
  // shape_short:'shape_short',
  // shape_very_short:'shape_very_short',
  // shape_tied_up:'shape_tied_up',
  // shape_ponytail:'shape_ponytail'
}

//notes 2023 : style is texture, (done )
// dreads added (done )
export const FEMALE_TEXTURE = {
  // style_straight:	'style_straight',
  // style_wavy:	'style_wavy',
  // style_curly:	'style_curly',
  // style_frizzy:	'style_frizzy'
  texture_curly:'texture_curly',
  texture_dreads:'texture_dreads',
  texture_frizzy:'texture_frizzy',
  texture_straight:'texture_straight',
  texture_wavy:'texture_wavy',
}
//2023 note: no change
export const FEMALE_FRINGE = {
  fringe_bangs_heavy:'fringe_bangs_heavy',
  fringe_bangs_parted:'fringe_bangs_parted',
  fringe_part_center:'fringe_part_center',
  fringe_part_side:'fringe_part_side',
  fringe_pulled_back:'fringe_pulled_back',
  fringe_sweep_side:'fringe_sweep_side',
}

export const FEMALE_SHAPE_MAP = {
  [FEMALE_SHAPE.style_long]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_straight_long',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_long',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_long',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_long',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_long',
  },
  [FEMALE_SHAPE.style_long_wide]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_wavy_long',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_long',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_long',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_long',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_long',
  },
  [FEMALE_SHAPE.style_medium]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_straight_medium',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_medium',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_medium',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_medium',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_medium',
  },
  [FEMALE_SHAPE.style_medium_wide]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_wavy_medium',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_medium',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_medium',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_medium',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_medium',
  },
  [FEMALE_SHAPE.style_short_spiky]:{//new - from style_short
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_straight_short',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_short',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_short',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_short',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_short',
  },
  [FEMALE_SHAPE.style_short]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_straight_short',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_wavy_short',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_wavy_short',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_female_frizzy_short',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_female_frizzy_short',
  },
  [FEMALE_SHAPE.style_very_short]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },
  [FEMALE_SHAPE.style_short_buzz_cut]:{ //new - from style_very_short
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_very_short',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },
  [FEMALE_SHAPE.style_tied_up]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_updo',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_updo',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_updok',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },
  [FEMALE_SHAPE.style_ponytail]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_back_female_ponytail',
    [FEMALE_TEXTURE.texture_wavy]:'hair_back_female_ponytail',
    [FEMALE_TEXTURE.texture_curly]:'hair_back_female_ponytail',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [FEMALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },
}


export const FEMALE_FRINGE_MAP = {
  [FEMALE_FRINGE.fringe_bangs_heavy]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_bangs',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_bangs',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_bangs',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_frizzy_side_part',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_frizzy_side_part',
  },

  [FEMALE_FRINGE.fringe_bangs_parted]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_very_short',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_very_short',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_very_short',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_frizzy_side_part',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_frizzy_side_part',
  },

  [FEMALE_FRINGE.fringe_part_center]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_middle_part',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_middle_part',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_middle_part',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_frizzy_middle_part',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_frizzy_middle_part',
  },

  [FEMALE_FRINGE.fringe_part_side]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_left_part',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_left_part',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_left_part',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_frizzy_side_part',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_frizzy_side_part',
  },

  [FEMALE_FRINGE.fringe_sweep_side]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_right_part',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_right_part',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_right_part',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_frizzy_side_part',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_frizzy_side_part',
  },

  [FEMALE_FRINGE.fringe_pulled_back]:{
    [FEMALE_TEXTURE.texture_straight]:'hair_front_female_pulled_back',
    [FEMALE_TEXTURE.texture_wavy]:'hair_front_female_pulled_back',
    [FEMALE_TEXTURE.texture_curly]:'hair_front_female_pulled_back',
    [FEMALE_TEXTURE.texture_frizzy]:'hair_front_female_hairline',
    [FEMALE_TEXTURE.texture_dreads]:'hair_front_female_hairline',
  },
}


/*MALE**********************************************************/

//2023 notes:additions noted below :  short_style_bowl (done), short_style_part_centre (done)
//2023 notes:additions noted below :  short_style_bowl (done), short_style_part_centre (done)
export const MALE_SHAPE = {
  short_style_standard:'short_style_standard',
  short_style_very_short:'short_style_very_short',
  short_style_part_side:'short_style_part_side',
  short_style_quiff:'short_style_quiff',
  short_style_crewcut:'short_style_crewcut',
  short_style_pulled_back:'short_style_pulled_back',
  short_style_large:'short_style_large',
  short_style_spikey_short:'short_style_spikey_short',
  short_style_spikey_long:'short_style_spikey_long',
  //2023 notes: not yet mapped below
  short_style_bowl:"short_style_bowl",
  short_style_part_centre:"short_style_part_centre",
}


//2023 notes: MALE_STYLE now maps as MALE TEXTURE, (done)
//not yet mapped : MALE_TEXTURE.texture_none (done)

//export const MALE_STYLE = {
  // style_straight:'style_straight',
  // style_wavy:'style_wavy',
  // style_curly:'style_curly',
  // style_frizzy:'style_frizzy',
  // style_dreads:'style_dreads',
//}
export const MALE_TEXTURE = {
  texture_curly:"texture_curly",
  texture_dreads:"texture_dreads",
  texture_frizzy:"texture_frizzy",
  texture_none:"texture_none",
  texture_straight:"texture_straight",
  texture_wavy:"texture_wavy",
}

/* 2023 NOTES removed:
fringe_spikey (done)
fringe_standard_fringe -> fringe_standard (done)
fringe_clean_cut (done)
fringe_sweep (done)

fringe_bangs_parted -> fringe_bangs (done)
  fringe_bangs_heavy -> fringe_bangs (done)

  added: fringe_none (done)
 */

export const MALE_FRINGE = {
  fringe_bangs:"fringe_bangs",
  fringe_none:"fringe_none",
  fringe_part_center:"fringe_part_center",
  fringe_part_side:"fringe_part_side",
  fringe_pulled_back:"fringe_pulled_back",
  fringe_quiff:"fringe_quiff",
  fringe_receding:"fringe_receding",
  fringe_standard:"fringe_standard",
  fringe_widows_peak:"fringe_widows_peak",

  //removed
  //fringe_spikey:'fringe_spikey',
  //fringe_clean_cut:'fringe_clean_cut',
  //fringe_sweep:'fringe_sweep',
}

//2023 notes: male-length: no change
export const MALE_LENGTH = {
  length_short:'length_short',
  length_long:'length_long',
  length_very_long:'length_very_long',
  length_buzz_cut:'length_buzz_cut',
  length_sides_only:'length_sides_only',
  length_bald:'length_bald',
}

export const MALE_SHAPE_MAP = {
  [MALE_SHAPE.short_style_standard]:{
    [MALE_TEXTURE.texture_straight]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_none]:'hair_back_male_spiked',
  },

  [MALE_SHAPE.short_style_very_short]:{
    [MALE_TEXTURE.texture_none]:'hair_back_male_short',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_short',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_short',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_short',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_part_side]:{
    [MALE_TEXTURE.texture_none]:'hair_back_male_short',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_short',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_short',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_part_centre]:{ // new - from short_style_part_side
    [MALE_TEXTURE.texture_none]:'hair_back_male_short',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_short',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_short',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_bowl]:{ // new - from short_style_part_side
    [MALE_TEXTURE.texture_none]:'hair_back_male_short',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_short',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_short',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },



  [MALE_SHAPE.short_style_quiff]:{
    [MALE_TEXTURE.texture_none]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_crewcut]:{
    [MALE_TEXTURE.texture_none]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_pulled_back]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'none',
    [MALE_TEXTURE.texture_wavy]:'none',
    [MALE_TEXTURE.texture_curly]:'none',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_afro',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_large]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_spikey_short]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },

  [MALE_SHAPE.short_style_spikey_long]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_spiked',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_afro',
  },
}

export const MALE_LENGTH_MAP = {
  [MALE_LENGTH.length_long]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_medium',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_medium',
  },

  [MALE_LENGTH.length_very_long]:{
    [MALE_TEXTURE.texture_none]:'none',
    [MALE_TEXTURE.texture_straight]:'hair_back_male_long',
    [MALE_TEXTURE.texture_wavy]:'hair_back_male_long',
    [MALE_TEXTURE.texture_curly]:'hair_back_male_long',
    [MALE_TEXTURE.texture_frizzy]:'hair_back_male_long',
    [MALE_TEXTURE.texture_dreads]:'hair_back_male_long',
  },
}

export const MALE_FRINGE_MAP = {
  [MALE_FRINGE.fringe_standard]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_long',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_long',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_long',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_long'
  },


  [MALE_FRINGE.fringe_bangs]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_long',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_long',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_long',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_long'
  },

  [MALE_FRINGE.fringe_part_center]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_long',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_long',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_long',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_long'
  },

  [MALE_FRINGE.fringe_part_side]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_long',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_long',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_long',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_long',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_long'
  },

  [MALE_FRINGE.fringe_pulled_back]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_short',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_short'
  },

  [MALE_FRINGE.fringe_widows_peak]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_hairline'
  },

  [MALE_FRINGE.fringe_receding]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_hairline',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_hairline'
  },

  [MALE_FRINGE.fringe_none]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_buzzed',
      [MALE_TEXTURE.texture_straight]:'hair_front_male_buzzed',
      [MALE_TEXTURE.texture_wavy]:'hair_front_male_buzzed',
      [MALE_TEXTURE.texture_curly]:'hair_front_male_buzzed',
      [MALE_TEXTURE.texture_frizzy]:'hair_front_male_buzzed',
      [MALE_TEXTURE.texture_dreads]:'hair_front_male_buzzed'
    },

  // [MALE_FRINGE.fringe_clean_cut]:{
  //   [MALE_TEXTURE.texture_straight]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_wavy]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_curly]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_frizzy]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_dreads]:'hair_front_male_buzzed'
  // },

  [MALE_FRINGE.fringe_quiff]:{
    [MALE_TEXTURE.texture_none]:'hair_front_male_buzzed',
    [MALE_TEXTURE.texture_straight]:'hair_front_male_short',
    [MALE_TEXTURE.texture_wavy]:'hair_front_male_short',
    [MALE_TEXTURE.texture_curly]:'hair_front_male_short',
    [MALE_TEXTURE.texture_frizzy]:'hair_front_male_short',
    [MALE_TEXTURE.texture_dreads]:'hair_front_male_short'
  },

  // [MALE_FRINGE.fringe_spikey]:{
  //   [MALE_TEXTURE.texture_straight]:'hair_front_male_hairline',
  //   [MALE_TEXTURE.texture_wavy]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_curly]:'hair_front_male_buzzed',
  //   [MALE_TEXTURE.texture_frizzy]:'hair_front_male_hairline',
  //   [MALE_TEXTURE.texture_dreads]:'hair_front_male_hairline'
  // },

  // [MALE_FRINGE.fringe_sweep]:{
  //   [MALE_TEXTURE.texture_straight]:'hair_front_male_long',
  //   [MALE_TEXTURE.texture_wavy]:'hair_front_male_long',
  //   [MALE_TEXTURE.texture_curly]:'hair_front_male_long',
  //   [MALE_TEXTURE.texture_frizzy]:'hair_front_male_long',
  //   [MALE_TEXTURE.texture_dreads]:'hair_front_male_long'
  // },
}

class HairAssetModel {
  constructor(){
    this.female = true
    this.auto_ml_payload = null
    this.detects = {}
  }


  setData(female, auto_ml_payload){
    this.female = female
    this.auto_ml_payload = auto_ml_payload

    this.detects = {}
    for(let o of this.auto_ml_payload){
      this.detects[o.displayName] = o.classification.score
    }

  }

  getMax(category){
    let max = 0
    let ko = ''
    for(let k in category){
      if (max < this.detects[k]){ko = k; max = this.detects[k]}
    }
    return ko
  }

  get TEXTURE(){return (this.female) ? FEMALE_TEXTURE : MALE_TEXTURE}
  get SHAPE(){return (this.female) ? FEMALE_SHAPE : MALE_SHAPE}
  get FRINGE(){return (this.female) ? FEMALE_FRINGE : MALE_FRINGE}

  get texture(){return this.getMax((this.TEXTURE))}
  get fringe(){ return this.getMax(this.FRINGE)}
  get shape(){ return this.getMax(this.SHAPE)}
  get male_length(){ return this.getMax(MALE_LENGTH)}

  get asset_back(){


    //FEMALE
    if (this.female){
      if(this.shape === FEMALE_SHAPE.style_tied_up){return 'none'}
      return FEMALE_SHAPE_MAP[this.shape][this.texture]
    }

    //return 'none'

    //MALE
    let L = this.male_length

    console.log('MALE FRINGE, length:'+this.male_length+ 'shape:' + this.shape + 'texture: '+this.texture)

    if (L === MALE_LENGTH.length_short){
      return MALE_SHAPE_MAP[this.shape][this.texture]
    }

    if (L === MALE_LENGTH.length_buzz_cut){return 'none'}
    if (L === MALE_LENGTH.length_sides_only){return 'none'}
    if (L === MALE_LENGTH.length_bald){return 'none'}

    return MALE_LENGTH_MAP[this.male_length][this.texture]
  }

  get asset_front(){


    //FEMALE
    if (this.female){
      if(this.shape === FEMALE_SHAPE.style_tied_up){return FEMALE_SHAPE_MAP[this.shape][this.texture]}
      return FEMALE_FRINGE_MAP[this.fringe][this.texture]
    }

    //return 'none'

    //MALE
    console.log('MALE FRINGE, fringe:'+this.fringe+' texture: '+this.texture)
    let fringe = MALE_FRINGE_MAP[this.fringe][this.texture]
    // if(fringe === 'N/A'){fringe = 'hair_front_male_short'}

    if(this.male_length === MALE_LENGTH.length_bald){fringe = 'none'}
    if(this.male_length === MALE_LENGTH.length_sides_only){fringe = 'none'}
    if(this.male_length === MALE_LENGTH.length_buzz_cut){fringe = 'hair_front_male_buzzed'}

    return fringe
  }
}

let m = new HairAssetModel()
export default m
